import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68c65a8e&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=coffee"
export * from "./index.vue?vue&type=script&lang=coffee"
import style0 from "./index.vue?vue&type=style&index=0&id=68c65a8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c65a8e",
  null
  
)

export default component.exports